import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Input, Select, Form, Skeleton } from "antd";
import DashboardRectangleCard from "../components/dashboard/DashboardRectangleCard";
import DashboardSmallCard from "../components/dashboard/DashboardSmallCard";
import Remarks from "../components/dashboard/Remarks";
import { HEADER_LOGO } from "@src/helpers/imagesConstants";
import DynamicTreeSelect from "@src/views/components/common/TreeSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  createSubjectOnBoardRemark,
  getMyOrganization,
  getSubjectOnBoardAnalysis,
  getSubjectOnBoardAnalysisRequest,
} from "@src/redux";
import Scrollbars from "react-custom-scrollbars-2";
import DashboardTotalCard from "../components/dashboard/DashboardTotalCard";
import { calculatePercentage, countFormat } from "@src/helpers/constants";

const { Title } = Typography;

type Props = {};

const Dashboard: React.FC = () => {
  const [organizationForm] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const organizationId = Form.useWatch("my_org", organizationForm);
  const {
    result: onBoardAnalysisItems,
    loading: onBoardAnalysisItemsLoading,
  } = useSelector(getSubjectOnBoardAnalysis);
  const { result: organization } = useSelector(getMyOrganization);

  // const organizationId = organizations;

  // organizations?.length > 0
  //   ? organizations[organizations?.length - 1] ||
  //     organizations[organizations?.length - 2] ||
  //     organization?.rootOrganization?.id
  //   : organization?.rootOrganization?.id;
  const totalSubjectCount =
    (onBoardAnalysisItems?.totalFemaleSubjectCount || 0) +
    (onBoardAnalysisItems?.totalMaleSubjectCount || 0) +
    (onBoardAnalysisItems?.totalThirdSubjectCount || 0);

  const totalVincenseSubjectCount =
    (onBoardAnalysisItems?.vincenseFemaleSubjectCount || 0) +
    (onBoardAnalysisItems?.vincenseMaleSubjectCount || 0) +
    (onBoardAnalysisItems?.vincenseThirdSubjectCount || 0);

  useEffect(() => {
    if (organization) {
      getSubjectOnBoardAnalysisRq(organizationId);
    }
  }, [organization, organizationId]);

  const getSubjectOnBoardAnalysisRq = (id) => {
    dispatch(
      getSubjectOnBoardAnalysisRequest({
        filter: {
          organizationId: id,
        },
      })
    );
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#d9d9d9",
      }}
    >
      <Row justify="center">
        <Title level={3}>ONBOARD ANALYSIS</Title>
      </Row>
      <Form
        form={organizationForm}
        layout="vertical"
        className="reading-filter-form"
        style={{ minHeight: "auto" }}
      >
        <Row gutter={16}>
          <DynamicTreeSelect
            form={organizationForm}
            mutationType={"add"}
            isRequired={false}
            allowClear={true}
            col={6}
            className={"reading-dashboard-organization-label"}
            key="dashboard_filter"
            fetchRequest={getSubjectOnBoardAnalysisRq}
          />
        </Row>
      </Form>
      <div className="dashboard-page-container">
        <div className="dashboard-cards-container">
          <div className="dashboard-wrapper">
            {onBoardAnalysisItemsLoading ? (
              <Skeleton.Input
                active
                style={{ width: "100%", height: "100%", minHeight: "250px" }}
                className="dashboard-rectangle-card"
              />
            ) : (
              <DashboardTotalCard
                label="Total"
                total={countFormat(totalSubjectCount)}
              />
            )}
            {onBoardAnalysisItemsLoading ? (
              <Skeleton.Input
                active
                style={{ width: "100%", height: "100%" }}
                className="dashboard-rectangle-card"
              />
            ) : (
              <DashboardRectangleCard
                color={"#e16096"}
                label="Vincense onboard"
                value={calculatePercentage(
                  totalVincenseSubjectCount,
                  totalSubjectCount
                )}
                total={totalVincenseSubjectCount}
              />
            )}
          </div>
          <div className="dashboard-container">
            <div className="dashboard-small-card-wrapper">
              {!onBoardAnalysisItemsLoading &&
                onBoardAnalysisItems?.subjectKeyCountList &&
                onBoardAnalysisItems?.subjectKeyCountList?.length > 0 &&
                onBoardAnalysisItems?.subjectKeyCountList?.map(
                  (item, index) => {
                    const totalValue =
                      (item?.femaleSubjectCount || 0) +
                      (item?.maleSubjectCount || 0) +
                      (item?.thirdSubjectCount || 0);
                    return (
                      <div key={index}>
                        <DashboardSmallCard
                          label={item?.subjectKey?.name || "No Name"}
                          value={totalValue}
                          loading={onBoardAnalysisItemsLoading}
                          percent={totalVincenseSubjectCount}
                        />
                      </div>
                    );
                  }
                )}
              {onBoardAnalysisItemsLoading && (
                <>
                  {" "}
                  {Array(4)
                    .fill(0, 0, 4)
                    .map((_, index) => (
                      <Skeleton.Input
                        key={index}
                        active
                        style={{ width: "100%", height: "250px" }}
                        className="dashboard-rectangle-card"
                      />
                    ))}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="remarks-container">
          <Remarks organizationId={organizationId} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
